<div
  class="w-full max-w-full"
  [class.mx-auto]="centered()"
  [class.mayorap-datepicker--invalid]="invalid()"
  [style.max-width]="maxWidth()"
>
  <p-datepicker
    [inputId]="inputId()"
    [ngModel]="value()"
    (ngModelChange)="onValueChange($event)"
    (onInput)="onDateInput($event)"
    (onBlur)="onDateBlur()"
    [disabled]="isDisabled()"
    [dateFormat]="dateFormat()"
    [maxDate]="maxDate()"
    [placeholder]="placeholder()"
    [keepInvalid]="true"
    [showIcon]="true"
    iconDisplay="input"
    [fluid]="true"
    appendTo="body"
    [autoZIndex]="true"
    styleClass="mayorap-datepicker__control w-full"
    inputStyleClass="w-full"
    [class.ng-invalid]="invalid()"
    [class.ng-dirty]="invalid()"
  />
</div>
